module.exports = __webpack_public_path__ + "img/c02.b44c830f.png";